import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventTourDetail {
	goodsCd: string;
	daySeq: number;
	dayNoSeq: number;
	tmSeq: number;
	trvSeq: number;
	trvInfoId: string;
	trvInfoYn: string;
	trvCd: string;
	tempCd: string;
	image1Url: string;
	image2Url: string;
	image3Url: string;
	image4Url: string;
	imageNm1: string;
	imageNm2: string;
	imageNm3: string;
	imageNm4: string;
	refeNote: string;
	optCost: string;
	useTm: string;
	infoNote: string;
	roomViewYn: string;
	trvInfoNm: string;
	trvContent: string;
	locNm: string;
	infoApiUrl: string;
}

/** ```
 * 행사 관광 정보
 *   `/pkg/event-schedule/{evCd}/tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventTourDetail";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-schedule/${evCd}/tour-detail`;
};

/** ```
 * 행사 관광 정보
 *   `/pkg/event-schedule/{evCd}/tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventTourDetail = (evCd: string, options?: Partial<UseQueryOptions<Response<EventTourDetail[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventTourDetail;
export {getPath};
export type {EventTourDetail};
